import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { Address } from '../interfaces/address';



@Injectable({
  providedIn: 'root',
})
export class UserAddresses {
  private apiUrl = `${environment.Server_URL}/addresses`;

  constructor(private http: HttpClient) {}

  // 📌 عرض كل العناوين
  getAddresses(): Observable<Address[]> {
    return this.http.get<Address[]>(this.apiUrl);
  }

  // 📌 عرض عنوان واحد
  getAddress(id: number): Observable<Address> {
    return this.http.get<Address>(`${this.apiUrl}/${id}`);
  }

  // 📌 إضافة عنوان جديد
  createAddress(address: Address): Observable<Address> {
    return this.http.post<Address>(this.apiUrl, address);
  }

  // 📌 تحديث عنوان
  updateAddress(id: number, address: Address): Observable<Address> {
    return this.http.put<Address>(`${this.apiUrl}/${id}`, address);
  }

  // 📌 حذف عنوان
  deleteAddress(id: number): Observable<any> {
    return this.http.delete(`${this.apiUrl}/${id}`);
  }
}
